import { useMemo } from "react";
import { useAuthInfo } from "../../../context/AuthContext";
import FormFieldSelect from "../../input/FormFieldSelect";

const ADMIN_ASSIGNABLE_ROLES = new Set(["admin", "user"]);

const UserRoleSelect = ({
  roleId,
  roles,
  userType,
  handleFieldUpdate,
  ...props
}) => {
  const { userInfo } = useAuthInfo();
  const isSuperAdmin = userInfo.role.name === "super-admin";

  const isDisabled = useMemo(
    () => userInfo.role.name === "user" || userType === "Contact",
    [userInfo.role, userType]
  );

  const renderRoles = () => {
    return roles?.map((role) => {
      if (!isSuperAdmin && role.name === "super-admin") {
        return null;
      }

      // Admins may only switch users between admin and user
      if (!isSuperAdmin && !ADMIN_ASSIGNABLE_ROLES.has(role.name)) {
        return null;
      }

      return (
        <option key={role.role_id} value={role.role_id}>
          {role.name}
        </option>
      );
    });
  };

  return (
    <FormFieldSelect
      name="roleId"
      label="Role *"
      placeholder="Select Role..."
      value={roleId}
      onChange={handleFieldUpdate}
      renderOptions={renderRoles}
      isDisabled={isDisabled}
      className={userType === "Contact" ? "contact-role-disabled" : ""}
      {...props}
    />
  );
};

export default UserRoleSelect;
